import React from 'react'
import {
  Route,
  IndexRoute,
} from 'react-router'

/** Route pages */
import Populator from 'populators/Signout'

const Signout = (store) => {
  const Routes = () => (
    <Route>
      <IndexRoute />
      <Route
        path="/logout"
        onEnter={(next, replace) => Populator.activity.onLogout(next, replace, store)}
      />
    </Route>
  )

  return Routes()
}

export default Signout
